<template>
  <div id="container" class="cart_st">
    <!-- 약관 동의 START-->
    <div class="section full">
      <div class="inner">
        <div class="btn_wrap" data-detail="shortcuts">
          <router-link :to="{ name: 'orders' }" class="box_btn line">
            <span class="c_icon ico_shortcuts_arrow"></span>
            <span class="an_t">{{ $t('views.member.logintoedit.6226') }}</span>
          </router-link>
        </div>
        <div class="box_wrap" data-detail="modify_detail">
          <div class="box tac">
            <div class="box_title">
              <h2>회원정보 수정</h2>
            </div>
            <div class="search_tab">
              <ul class="mx-auto">
                <li class="input_wrap chk_round">
                  <div class="text_label">
                    <label>
                      <input
                        v-model="recoverBy"
                        type="radio"
                        name="recoverByPhone"
                        class="chk_agree"
                        checked=""
                        value="phone"
                      />
                      <em></em>
                      <span>휴대폰 번호로 인증하기</span>
                    </label>
                  </div>
                </li>
              </ul>
            </div>
            <!-- <div class="modify_align">
              <ul class="form_wrap">
                <li>
                  <label for="inputEmail">
                    <p class="sub_title">
                      {{ $t('views.member.logintoedit.5075') }}
                    </p>
                    <div class="input_wrap">
                      <input
                        id="inputEmail"
                        v-model="username"
                        class="input_t"
                        type="email"
                        name="name"
                        placeholder=""
                      />
                    </div>
                  </label>
                </li>
                <li class="correct">
                  <label for="inputPW">
                    <p class="sub_title">
                      {{ $t('views.member.logintoedit.5885') }}
                    </p>
                    <div class="input_wrap">
                      <input
                        id="inputPW"
                        v-model="password"
                        class="input_t"
                        type="password"
                        maxlength="16"
                        name="user_password"
                        @keydown.enter="checkAuth"
                      />
                    </div>
                  </label>
                  <p v-if="error" class="txt_message">
                    <span>{{ $t('views.member.logintoedit.2037') }}</span>
                  </p>
                </li>
              </ul>
            </div> -->
            <div class="btn_wrap mt">
              <button class="box_btn verty" tabindex="0" @click="verify">
                <span class="an_t">본인 인증</span>
              </button>
            </div>

            <!-- <div class="btn_wrap" data-detail="btn_bottom">
              <router-link :to="{ name: 'orders' }" class="box_btn dull">
                <span class="an_t">취소</span>
              </router-link>
              <!- 비밀번호가 일치하지 않을 때 : 알럿창 alert_msg('incorrect')->
              <a class="box_btn" @click="checkAuth">
                <span class="an_t">확인</span>
              </a>
            </div> -->
          </div>
        </div>
      </div>
    </div>
    <!-- 약관 동의 END-->
    <!-- ERROR MODAL -->
    <transition v-on-clickaway="toggleErrorModal" name="modal-fade">
      <Modal v-if="showErrorModal" @close="toggleErrorModal">
        <div class="ly_pop_wrap">
          <div class="ly_pop_content ly_pop_msg ly_txt">
            <div class="ly_pop_head">
              <a class="btn_ly_close svg_close" @click="toggleErrorModal"
                ><span>{{ $t('library.deletemodal.close') }}</span></a
              >
            </div>
            <div class="ly_inner">
              <p>
                {{ errorMessage }}
              </p>
              <div class="btnWrap">
                <button class="box_btn w-full alert" @click="toggleErrorModal">
                  <span class="an_t">{{
                    $t('library.deletemodal.close')
                  }}</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </transition>
    <Iamport />
  </div>
</template>

<script>
import { AUTH_CHECK_CRED } from '@/store/types'
import { mapGetters } from 'vuex'
import { v4 as uuidv4 } from 'uuid'

export default {
  name: 'LoginToEdit',
  data() {
    return {
      recoverBy: 'phone',
      error: null,
      showErrorModal: false,
      errorMessage: '',

      password: ''
    }
  },
  computed: {
    ...mapGetters(['getAuthErrorMessage', 'getCurrentUser'])
  },
  methods: {
    toggleErrorModal(errorMessage) {
      this.errorMessage = errorMessage
      this.showErrorModal = !this.showErrorModal
    },
    async checkAuth() {
      const { password } = this
      try {
        await this.$store.dispatch(AUTH_CHECK_CRED, { password })
        this.password = ''
        this.$router.push({ name: 'edit_account', params: { verified: true } })
      } catch (err) {
        this.toggleErrorModal()
      }
    },
    async verify() {
      if (this.recoverBy === 'phone') {
        this.startPhoneAuth()
      }
    },
    generateMerchantId() {
      return `ORD-${uuidv4()}`
    },
    startPhoneAuth() {
      const info = {
        findTp: this.recoverBy
      }
      window.IMP.certification(
        {
          merchant_uid: this.generateMerchantId(),
          popup: true
        },
        async (rsp) => {
          if (rsp.success) {
            info.impUid = rsp.imp_uid
            try {
              await this.$store.dispatch(AUTH_CHECK_CRED, info)
              this.$router.push({
                name: 'edit_account',
                params: { verified: true }
              })
            } catch (err) {
              // show modal error msg from server (서버 커스텀 에러 메시지 표시 하도록 변경)
              this.toggleErrorModal(
                `[${err.response.data.errorState.code}] ${err.response.data.errorState.message}`
              )
            }
          } else {
            this.toggleErrorModal(rsp.error_msg)
          }
        }
      )
    }
  }
}
</script>
<style src="@/assets/css/page_member.css" scoped></style>
<style src="@/assets/css/page_join.css" scoped></style>
<style lang="scss" scoped>
.search_tab .text_label input[type='radio'] + em + span {
  margin-left: 15px;
  line-height: 32px;
  font-size: 16px;
  color: #444444;
}
.box_title {
  margin-bottom: 25px;
}
.btn_wrap.mt {
  margin-top: 13px;
}
.cart_st {
  .box_btn {
    &.alert {
      width: 50%;
    }
    &.verty {
      width: 100%;
      height: 56px;
      background: #008df3;
      border-radius: 12px;
      border: none;
      .an_t {
        font-size: 18px;
        line-height: 56px;
        letter-spacing: 0;
      }
    }
  }
  .box_wrap {
    width: 600px;
    margin: 0 auto;
    padding: 25px 35px 45px;
    .box {
      width: auto;
    }
  }
}
@media (max-width: 768px) {
  .cart_st .box_wrap {
    width: auto;
  }
}
</style>
